import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';

type TIsRequestValid = (status?: number) => boolean;

const isNotAuthorized: TIsRequestValid = (status) => status === httpErrorsTypes.NOT_AUTHORIZED;
const isBadRequest: TIsRequestValid = (status) => status === httpErrorsTypes.BAD_REQUEST;
const isServiceUnavailable: TIsRequestValid = (status) => status === httpErrorsTypes.SERVICE_UNAVAILABLE;

export default {
    isNotAuthorized,
    isBadRequest,
    isServiceUnavailable,
};
